export const CATEGORIES_ACTION_TYPES = {
  FETCH_CATEGORIES_START: "categories/[CATEGORIES] fetch start",
  FETCH_CATEGORIES_SUCCESS: "categories/[CATEGORIES] fetch success",
  FETCH_CATEGORIES_FAILED: "categories/[CATEGORIES] fetch failed",
};
